// 记录当前打开画布的 canvasId / branchId，供 axios 拦截器注入请求头
let canvasId = "";
let branchId = "";

export function setCanvasContext(id, bid) {
  canvasId = id || "";
  branchId = bid || "";
}
export function clearCanvasContext() {
  canvasId = "";
  branchId = "";
}
export function getCanvasContext() {
  return { canvasId, branchId };
}
